import { Study, StudyType } from '@/shared/api/protocol-ts/model/dto_study_pb';

export const isSecondaryStudy =
  (studyID: string, studyType: StudyType) => (study: Study) =>
    study.Type === studyType && study.ID !== studyID;
